export const EVAL_STATUS_MAPPING = {
    PENDING: "assessment_evaluating",
    FAILED: "assessment_failed",
    SUCCESS: "assessment_passed",
}
